import styled from "styled-components";

export const StyledSearchContainer = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: 31px;
  transform: translateY(-50%);
  width: calc(100% - 34px);

  svg {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const StyledSearchInput = styled.input`
  border-radius: 6px;
  padding-right: 20px;
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  line-height: normal;
`;

export const StyledSuggestionsContainer = styled.div`
  input {
    font-size: 10px !important;
    background-color: #fafafa !important;

    :placeholder {
      font-size: 10px !important;
    }
  }

  label {
    font-size: 10px !important;
    background: #fafafa;
  }

  button {
    font-size: 12px !important;

    svg {
      width: 12px !important;
      height: 12px !important;
    }
  }

  .panel-dd-container {
    margin-bottom: 0px !important;
  }

  .coordinate-switch {
    div {
      font-size: 8px !important;
    }
  }
`;
